import { DeleteContentOutDto, DeleteContentInDto } from '../../../types/content.dto'

export const DELETE_CUSTOM_CONTENT_TYPE = 'DELETE_CUSTOM_CONTENT_TYPE'
export const DELETE_CUSTOM_CONTENT_TYPE_SUCCESS = 'DELETE_CUSTOM_CONTENT_TYPE_SUCCESS'
export const DELETE_CUSTOM_CONTENT_TYPE_ERROR = 'DELETE_CUSTOM_CONTENT_TYPE_ERROR'
export const RESET_DELETE_CUSTOM_CONTENT_TYPE = 'RESET_DELETE_CUSTOM_CONTENT_TYPE'

export interface DeleteCustomContentType {
  type: typeof DELETE_CUSTOM_CONTENT_TYPE
  payload: DeleteContentOutDto
}

export interface DeleteCustomContentTypeSuccess {
  type: typeof DELETE_CUSTOM_CONTENT_TYPE_SUCCESS
  payload: DeleteContentInDto
}

export interface DeleteCustomContentTypeError {
  type: typeof DELETE_CUSTOM_CONTENT_TYPE_ERROR
  payload: string | boolean
}

export interface ResetDeleteCustomContentType {
  type: typeof RESET_DELETE_CUSTOM_CONTENT_TYPE
  payload: null
}

export interface State {
  data: DeleteContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | DeleteCustomContentType
  | DeleteCustomContentTypeSuccess
  | DeleteCustomContentTypeError
  | ResetDeleteCustomContentType
